import { Component, Input, OnInit } from '@angular/core';
import { DatosFirmaService } from 'src/app/pages/panelControl/services/datos-firma.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { Router } from '@angular/router';
import { TooltipMessages } from 'src/app/shared/models/tooltip.mesages';
import { ResumenInicial } from 'src/app/pages/panelControl/models/resumen-inicial';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';


@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit {

   filtrosSqp: FiltroSqp[] = [];
   resumenInicial: ResumenInicial;
   sumaNuevos: number = 0;
   filtroFechaEnvio: FiltroSqp

  constructor(public datosFirmasService: DatosFirmaService,
              private _snackBar: MatSnackBar,
              private loginService: LoginService,
              private router: Router) {}

  ngOnInit() {
    this.cargarResumenInicial();
  }

  getNameLogin(){
    let userData = this.loginService.getUserLocalStorage();
    return (userData.User.Nombre) ? `${userData.User.Nombre}` : userData.User.Login;
  }

  navega(id: string){
    switch(id) {
      case 'NUEVAS':
        this.router.navigate(['/panel/envios/nuevos']);
        break;
      case 'ESTANDAR':
        this.router.navigate(['/panel/subida'], {queryParams: {'envio': 'estandar'}});
        break;
      case 'UNIVERSAL':
        this.router.navigate(['/panel/subida'], {queryParams: {'envio': 'universal'}});
        break;
      case 'FIRMAS':
        this.router.navigate(['/panel/envios']);
        break;
      case 'EMPLEADOS':
        this.router.navigate(['/panel/configuracion/empleados']);
        break;
      case 'DOCUMENTOS':
        this.router.navigate(['/panel/documentos-configurados']);
        break;
      case 'INCOMPLETOS':
        this.router.navigate(['/panel/dosieres-configurados/incompletos'])
    }
  }

  getTooltip(){
    return TooltipMessages.envio_nuevos;
  }

  cargarResumenInicial(){
    this.filtroFechaEnvio = this.datosFirmasService.montarFiltroFechaEnvio();
    this.filtrosSqp.push(this.filtroFechaEnvio);
    this.datosFirmasService.cargaResumenHome(this.filtrosSqp).subscribe(
      next => {
        this.resumenInicial = next;
        this.sumaNuevos = this.getNuevos();

      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  getNuevos(): number {
    return this.resumenInicial.ResumenEstados.find(x => x.tipoEstado === 'todos')?.nuevos || 0;
  }

}
